// === helpers =================================================================

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// === end helpers =============================================================

// === event_subscription ======================================================

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}

// === end event_subscription ==================================================

// === trap_focus ==============================================================

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== "TAB") {
      return; // If not TAB key
    }

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
  }
}

// === end trap_focus ==========================================================

// === polyfill ================================================================

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", () => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) {
        currentFocusedElement.classList.remove("focused");
      }

      if (mouseClick) {
        return;
      }

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

// === end polyfill ============================================================

// === Shopify =================================================================

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// === end Shopify =============================================================

// === web_components ==========================================================

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetails = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });

    this.querySelectorAll("[data-menu-drawer-submenu-close-button]").forEach(
      (button) => {
        button.addEventListener(
          "click",
          this.onSubmenuCloseButtonClick.bind(this),
        );
      },
    );

    this.querySelectorAll("[data-menu-drawer-click-to-close]").forEach(
      (element) => {
        element.addEventListener("click", this.onClickToCloseClick.bind(this));
      },
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") {
      return;
    }

    const openDetailsElement = event.target.closest("details[open]");

    if (!openDetailsElement) {
      return;
    }

    openDetailsElement === this.mainDetails
      ? this.closeMenuDrawer(event, this.mainDetails.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(
      "[data-menu-drawer-has-submenu]",
    );
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (parentMenuElement) {
      parentMenuElement.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-drawer--menu-opening");
      });
    }

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetails) {
      if (isOpen) {
        event.preventDefault();
      }

      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-drawer--menu-opening");
        parentMenuElement &&
          parentMenuElement.classList.add("menu-drawer--submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetails.classList.add("menu-drawer--menu-opening");
    });

    trapFocus(this.mainDetails, summaryElement);
    document.body.classList.add("hide-overflow");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) {
      return;
    }

    this.mainDetails.classList.remove("menu-drawer--menu-opening");

    this.mainDetails.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-drawer--menu-opening");
    });

    this.mainDetails
      .querySelectorAll(".menu-drawer--submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("menu-drawer--submenu-open");
      });

    document.body.classList.remove("hide-overflow");
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetails);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetails.hasAttribute("open") &&
        !this.mainDetails.contains(document.activeElement)
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onClickToCloseClick(event) {
    if (!event.target.closest("[data-menu-drawer-main-content]")) {
      this.closeMenuDrawer(event, this.mainDetails.querySelector("summary"));
    }
  }

  onSubmenuCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(
      ".menu-drawer--submenu-open",
    );
    parentMenuElement &&
      parentMenuElement.classList.remove("menu-drawer--submenu-open");
    detailsElement.classList.remove("menu-drawer--menu-opening");
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".header-section");
    this.header.preventHide = true;

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );

    this.header.classList.add("header-drawer--menu-open");
    this.onResizeHandler = this.onResizeHandler || this.onResize.bind(this);
    window.addEventListener("resize", this.onResizeHandler);
    super.openMenuDrawer(summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) {
      return;
    }

    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("header-drawer--menu-open");
    this.header.preventHide = false;
    window.removeEventListener("resize", this.onResizeHandler);
  }

  onResize() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  }
}

customElements.define("header-drawer", HeaderDrawer);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slideList = this.querySelector("[data-slider-component-slide-list]");
    this.slides = Array.from(
      this.querySelectorAll("[data-slider-component-slide]"),
    );
    this.prevButton = this.querySelector("[data-slider-component-prev-button]");
    this.nextButton = this.querySelector("[data-slider-component-next-button]");
    this.indicatorList = this.querySelector(
      "[data-slider-component-indicator-list]",
    );
    this.indicators = Array.from(
      this.querySelectorAll("[data-slider-component-indicator]"),
    );
    this.dotButtons = Array.from(
      this.querySelectorAll("[data-slider-component-dot-button]"),
    );

    if (!this.slideList) {
      return;
    }

    if (this.indicatorList) {
      const paddingInlineStart = window
        .getComputedStyle(this.indicatorList)
        .getPropertyValue("padding-inline-start")
        .replace("px", "");

      if (paddingInlineStart.length > 0) {
        this.indicatorListPaddingInlineStart = parseInt(paddingInlineStart);
      } else {
        this.indicatorListPaddingInlineStart = 0;
      }
    }

    this.initPages();
    const resizeObserver = new ResizeObserver(() => {
      this.initPages();
    });
    resizeObserver.observe(this.slideList);

    this.slideList.addEventListener("scroll", this.update.bind(this));

    if (this.prevButton) {
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }

    this.dotButtons.forEach((dotButton) => {
      dotButton.addEventListener("click", this.onDotButtonClick.bind(this));
    });

    if (this.slides.length > 1) {
      if (this.hasAttribute("data-slider-component-auto-scroll")) {
        this.autoScrollIntervalId = setInterval(() => {
          if (
            document.activeElement !== this.slideList &&
            !this.slideList.matches(":hover")
          ) {
            const currentIndex = this.currentPage - 1;

            if (currentIndex === this.slides.length - 1) {
              this.switchSlide(-currentIndex);
            } else {
              this.switchSlide(1);
            }
          }
        }, 5000);
      }
    }
  }

  initPages() {
    if (this.slides.length < 2) {
      return;
    }

    this.sliderItemOffset =
      this.slides[1].offsetLeft - this.slides[0].offsetLeft;

    if (this.sliderItemOffset > 0) {
      this.update();
    }
  }

  resetPages() {
    this.slides = Array.from(
      this.querySelectorAll("[data-slider-component-slide]"),
    );
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slideList) {
      return;
    }

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slideList.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slide-changed", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.slides[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.prevButton) {
      if (
        this.isSlideVisible(this.slides[0]) &&
        this.slideList.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "");
      } else {
        this.prevButton.removeAttribute("disabled");
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.slides[this.slides.length - 1])) {
        this.nextButton.setAttribute("disabled", "");
      } else {
        this.nextButton.removeAttribute("disabled");
      }
    }

    if (this.indicators.length > 0) {
      const currentIndicator = this.indicators[this.currentPage - 1];

      this.indicators.forEach((indicator) => {
        indicator.removeAttribute("aria-current");
      });

      currentIndicator.setAttribute("aria-current", true);
      this.indicatorList.scrollTo({
        left:
          currentIndicator.offsetLeft - this.indicatorListPaddingInlineStart,
      });
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slideList.clientWidth + this.slideList.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slideList.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget === this.nextButton ? 1 : -1;
    this.switchSlide(step);
  }

  // `step` should be positive to go to next `step` slides, negative to go to previous `step` slides.
  switchSlide(step, behavior = "auto") {
    const currentIndex = this.currentPage - 1;
    const currentLeft = this.slides[currentIndex].offsetLeft;
    const position = currentLeft + step * this.sliderItemOffset;

    if (!this.hasAttribute("data-slider-component-animate")) {
      this.slideList.scrollTo({
        left: position,
        behavior,
      });

      return;
    }

    const nextIndex = currentIndex + step;

    if (nextIndex >= this.slides.length || nextIndex < 0) {
      return;
    }

    const direction = step > 0 ? "next" : "prev";
    const duration = 150;
    this.slides[currentIndex].classList.add(`animate-out-${direction}`);
    this.slides[nextIndex].classList.add(`animate-in-${direction}`);

    setTimeout(() => {
      this.slideList.scrollTo({
        left: position,
      });
    }, duration);

    setTimeout(() => {
      this.slides[currentIndex].classList.remove(`animate-out-${direction}`);
      this.slides[nextIndex].classList.remove(`animate-in-${direction}`);
    }, duration * 2);
  }

  onDotButtonClick(event) {
    event.preventDefault();

    const index = this.dotButtons.indexOf(event.currentTarget);
    const position = this.slides[index].offsetLeft;

    if (!this.hasAttribute("data-slider-component-animate")) {
      this.slideList.scrollTo({
        left: position,
      });

      return;
    }

    const nextIndex = index;
    const currentIndex = this.currentPage - 1;
    const direction = index > currentIndex ? "next" : "prev";

    const duration = 150;
    this.slides[currentIndex].classList.add(`animate-out-${direction}`);
    this.slides[nextIndex].classList.add(`animate-in-${direction}`);

    setTimeout(() => {
      this.slideList.scrollTo({
        left: position,
      });
    }, duration);

    setTimeout(() => {
      this.slides[currentIndex].classList.remove(`animate-out-${direction}`);
      this.slides[nextIndex].classList.remove(`animate-in-${direction}`);
    }, duration * 2);
  }
}

customElements.define("slider-component", SliderComponent);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();

    this.detailsList = Array.from(this.querySelectorAll("details"));
    this.detailsList.forEach((details) => {
      details
        .querySelector("summary")
        .addEventListener("click", this.onSummaryClick.bind(this, details));
    });
  }

  onSummaryClick(details, event) {
    event.preventDefault();

    if (details.hasAttribute("open")) {
      this.applyCloseAnimation(details);
    } else {
      for (const otherDetails of this.detailsList) {
        if (otherDetails !== details && otherDetails.hasAttribute("open")) {
          this.applyCloseAnimation(otherDetails);
        }
      }

      this.applyOpenAnimation(details);
    }
  }

  applyOpenAnimation(details) {
    const collapsedHeight = details.offsetHeight;
    details.setAttribute("open", "");
    const expandedHeight = details.offsetHeight;

    details.animate(
      [{ height: `${collapsedHeight}px` }, { height: `${expandedHeight}px` }],
      {
        duration: 150,
        easing: "ease-out",
      },
    );
  }

  applyCloseAnimation(details) {
    const expandedHeight = details.offsetHeight;
    details.removeAttribute("open");
    const collapsedHeight = details.offsetHeight;
    details.setAttribute("open", "");

    const animation = details.animate(
      [{ height: `${expandedHeight}px` }, { height: `${collapsedHeight}px` }],
      {
        duration: 150,
        easing: "ease-out",
      },
    );

    animation.onfinish = () => {
      details.removeAttribute("open");
    };
  }
}

customElements.define("accordion-component", AccordionComponent);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetails = this.querySelector("details");
    this.content = this.mainDetails.querySelector("summary").nextElementSibling;

    this.mainDetails.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetails.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 200);
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetails.hasAttribute("open")) {
      this.animations.forEach((animation) => {
        animation.play();
      });
    } else {
      this.animations.forEach((animation) => {
        animation.cancel();
      });
    }
  }

  close() {
    this.mainDetails.removeAttribute("open");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector("[data-modal-dialog-close]").addEventListener(
      "click",
      this.hide.bind(this, false),
    );

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });

    if (this.matches("[data-media-modal]")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) {
      return;
    }

    this.moved = true;
    this.dataset.section = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      "",
    );
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector("[data-modal-dialog-template-popup]");
    document.body.classList.add("hide-overflow");
    this.setAttribute("open", "");

    if (popup) {
      popup.loadContent();
    }

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("hide-overflow");
    document.body.dispatchEvent(new CustomEvent("modal-closed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class RadioComponent extends HTMLElement {
  constructor() {
    super();

    this.itemList = Array.from(
      this.querySelectorAll("[data-radio-component-item]"),
    );
    this.itemList.forEach((item) => {
      item.addEventListener("click", this.onItemClick.bind(this, item));
    });
  }

  onItemClick(item, event) {
    if (item.hasAttribute("aria-expanded")) {
      item.removeAttribute("aria-expanded");
    } else {
      for (const otherItem of this.itemList) {
        if (otherItem !== item && otherItem.hasAttribute("aria-expanded")) {
          otherItem.removeAttribute("aria-expanded");
        }
      }

      item.setAttribute("aria-expanded", true);
    }
  }
}

customElements.define("radio-component", RadioComponent);

class ScrollerComponent extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector("[data-scroller-component-content]");
    this.scrollbar = this.querySelector("[data-scroller-component-scrollbar]");

    const resizeObserver = new ResizeObserver(() => {
      this.onContentScroll();
    });
    resizeObserver.observe(this.content);

    this.content.addEventListener("scroll", this.onContentScroll.bind(this));
  }

  onContentScroll() {
    const scrollbarWidth = this.content.clientWidth / this.content.scrollWidth;
    const scrollbarLeft =
      (this.content.scrollLeft * this.scrollbar.scrollWidth) /
      this.content.scrollWidth;
    const scrollbarHeight =
      this.content.clientHeight / this.content.scrollHeight;
    const scrollbarTop =
      (this.content.scrollTop * this.scrollbar.scrollHeight) /
      this.content.scrollHeight;
    this.style.setProperty("--scrollbar-width", `${scrollbarWidth * 100}%`);
    this.style.setProperty("--scrollbar-left", `${scrollbarLeft}px`);
    this.style.setProperty("--scrollbar-height", `${scrollbarHeight * 100}%`);
    this.style.setProperty("--scrollbar-top", `${scrollbarTop}px`);

    if (scrollbarWidth === 1 && scrollbarHeight === 1) {
      this.setAttribute("data-scroller-component-no-overflow", "");
    } else {
      this.removeAttribute("data-scroller-component-no-overflow");
    }
  }
}

customElements.define("scroller-component", ScrollerComponent);

class VideoComponent extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");

    if (!this.video) {
      return;
    }

    this.playButton = this.querySelector("[data-video-component-play-button]");

    if (!this.playButton) {
      return;
    }

    this.thumbnail = this.querySelector("[data-video-component-thumbnail]"); // Optional

    this.video.addEventListener("ended", this.onVideoEnded.bind(this));
    this.video.addEventListener("click", this.onPlayPause.bind(this));
    this.playButton.addEventListener("click", this.onPlayPause.bind(this));

    if (this.thumbnail) {
      this.thumbnail.addEventListener("click", this.onPlayPause.bind(this));
    }
  }

  onVideoEnded() {
    this.removeAttribute("data-video-component-is-playing");
  }

  onPlayPause() {
    if (this.video.paused) {
      this.video.play();
      this.setAttribute("data-video-component-is-playing", "");
    } else {
      this.video.pause();
      this.removeAttribute("data-video-component-is-playing");
    }
  }
}

customElements.define("video-component", VideoComponent);

class TabComponent extends HTMLElement {
  constructor() {
    super();

    this.tabs = Array.from(this.querySelectorAll("[data-tab-component-tab]"));
    this.tabPanels = Array.from(
      this.querySelectorAll("[data-tab-component-tab-panel]"),
    );
    this.tabList = this.querySelector("[data-tab-component-tab-list]");
    this.currentIndex = 0;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this));
    });

    this.tabList.addEventListener("keydown", this.onTabListKeyDown.bind(this));
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const index = this.tabs.indexOf(tab);
    this.changeTab(index);
  }

  onTabListKeyDown(event) {
    if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
      let index;

      if (event.key === "ArrowRight") {
        index = this.currentIndex + 1;

        if (index >= this.tabs.length) {
          index = 0;
        }
      } else {
        index = this.currentIndex - 1;

        if (index < 0) {
          index = this.tabs.length - 1;
        }
      }

      this.tabs[this.currentIndex].tabIndex = -1;
      this.tabs[index].tabIndex = 0;
      this.tabs[index].focus();
      this.changeTab(index);
    }
  }

  changeTab(index) {
    this.tabs[this.currentIndex].setAttribute("aria-selected", "false");
    this.tabs[this.currentIndex].tabindex = -1;
    this.tabs[index].setAttribute("aria-selected", "true");
    this.tabs[index].tabindex = 0;

    this.tabPanels[this.currentIndex].setAttribute("hidden", "");
    this.tabPanels[index].removeAttribute("hidden");

    this.currentIndex = index;
  }
}

customElements.define("tab-component", TabComponent);

class IntersectionTracker extends HTMLElement {
  constructor() {
    super();

    this.onWindowScrollCallback = this.onWindowScroll.bind(this);

    const observer = new IntersectionObserver(this.onIntersect.bind(this));
    observer.observe(this);

    const rect = this.getBoundingClientRect();
    this.updateScrollEvent(rect.bottom > 0 && rect.top < window.innerHeight);
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.target === this) {
        this.updateScrollEvent(entry.isIntersecting);
      }
    });
  }

  onWindowScroll() {
    const rect = this.getBoundingClientRect();
    this.style.setProperty("--intersection-top", `${rect.top}px`);
    this.style.setProperty("--intersection-bottom", `${rect.bottom}px`);
  }

  updateScrollEvent(isIntersecting) {
    if (isIntersecting) {
      window.addEventListener("scroll", this.onWindowScrollCallback);
      this.onWindowScroll();
    } else {
      window.removeEventListener("scroll", this.onWindowScrollCallback);
    }
  }
}

customElements.define("intersection-tracker", IntersectionTracker);

class DragToScroll extends HTMLElement {
  constructor() {
    super();

    this.isDown = false;
    this.startX = 0;
    this.startY = 0;
    this.scrollLeftStart = 0;
    this.scrollTopStart = 0;
    this.panel = this.querySelector("[data-drag-to-scroll-panel]");
    this.slider = this.querySelector("[data-drag-to-scroll-slider]"); // Optional

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);

    this.querySelectorAll("img").forEach((image) => {
      image.setAttribute("draggable", false);
    });
    this.querySelectorAll("a").forEach((anchor) => {
      anchor.setAttribute("draggable", false);
      anchor.addEventListener("click", this.onAnchorClick.bind(this));
    });
  }

  connectedCallback() {
    this.panel.addEventListener("mousedown", this.handleMouseDown);
    this.panel.addEventListener("mouseleave", this.handleMouseLeave);
    this.panel.addEventListener("mouseup", this.handleMouseUp);
    this.panel.addEventListener("mousemove", this.handleMouseMove);
  }

  disconnectedCallback() {
    this.panel.removeEventListener("mousedown", this.handleMouseDown);
    this.panel.removeEventListener("mouseleave", this.handleMouseLeave);
    this.panel.removeEventListener("mouseup", this.handleMouseUp);
    this.panel.removeEventListener("mousemove", this.handleMouseMove);
  }

  handleMouseDown(e) {
    // Only activate for main mouse button (usually left)
    if (e.button !== 0) return;

    this.isDown = true;
    this.panel.setAttribute("dragging", ""); // Add attribute for styling
    this.panel.style.setProperty("scroll-behavior", "auto");
    this.panel.style.setProperty("scroll-snap-type", "none");
    this.startX = e.pageX - this.panel.offsetLeft; // Position relative to the element
    this.startY = e.pageY - this.panel.offsetTop; // Position relative to the element
    this.scrollLeftStart = this.panel.scrollLeft;
    this.scrollTopStart = this.panel.scrollTop;
  }

  handleMouseLeave() {
    if (!this.isDown) return;
    // If mouse leaves while dragging, stop the drag
    this.isDown = false;
    this.panel.removeAttribute("dragging");
    this.panel.style.removeProperty("scroll-behavior");
    this.panel.style.removeProperty("scroll-snap-type");
  }

  handleMouseUp(e) {
    // Only react if a drag was initiated from this element
    if (!this.isDown) return;

    if (this.slider) {
      const x = e.pageX - this.panel.offsetLeft;
      const walkX = x - this.startX;

      if (walkX < -30) {
        this.slider.switchSlide(1, "smooth");
      } else if (walkX > 30) {
        this.slider.switchSlide(-1, "smooth");
      }

      setTimeout(() => {
        this.panel.style.removeProperty("scroll-behavior");
        this.panel.style.removeProperty("scroll-snap-type");
      }, 600);
    } else {
      this.panel.style.removeProperty("scroll-behavior");
      this.panel.style.removeProperty("scroll-snap-type");
    }

    this.isDown = false;
    setTimeout(() => {
      this.isDragging = false;
    }, 200);
    this.panel.removeAttribute("dragging");
  }

  handleMouseMove(e) {
    if (!this.isDown) return; // Only run if mouse is down

    e.preventDefault(); // Prevent text selection etc. during drag

    const x = e.pageX - this.panel.offsetLeft;
    const y = e.pageY - this.panel.offsetTop;
    const walkX = x - this.startX; // How far mouse moved horizontally
    const walkY = y - this.startY; // How far mouse moved vertically

    // Update scroll position based on mouse movement
    // Subtract walk because dragging right should move content left (increase scrollLeft)
    this.panel.scrollLeft = this.scrollLeftStart - walkX;
    this.panel.scrollTop = this.scrollTopStart - walkY;

    this.isDragging = true;
  }

  onAnchorClick(e) {
    if (this.isDragging) {
      e.preventDefault();
    }
  }
}

customElements.define("drag-to-scroll", DragToScroll);

class ScrollToTop extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("[data-scroll-to-top-button]");
    this.button.addEventListener("click", this.onButtonClick.bind(this));
    window.addEventListener("scroll", this.onWindowScroll.bind(this));
  }

  onButtonClick() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  onWindowScroll() {
    this.hidden = window.scrollY <= document.documentElement.clientHeight;
  }
}

customElements.define("scroll-to-top", ScrollToTop);

// === end web_components ======================================================

// === ? =======================================================================
